import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSnackbar } from 'notistack';
import CustomSelect from '../../../../components/form/CustomSelect';
import { Rules } from '../../../../helpers/RHFRules';
import CustomInput from '../../../../components/form/CustomInput';
import EditCertificationServiceModify from './EditCertificationServiceModify';
import AlertConfirm from '../../../../components/crosscutting/confirmationWindows/AlertConfirm';
import WarningIcon from '../../../../components/IconsLibrary/WarningIcon';
import SuccesfullIcon from '../../../../components/IconsLibrary/SuccesfullIcon';
import NumberFormatCustom from '../../../../components/form/NumberFormatCustom';
import { getDeviceTye } from '../../../../helpers/generalUtils';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

/**
 * Set dinamic styles for Dialog
 * @param {*} theme mui material theme
 * @param {*} firstImageIcon First icon
 * @param {*} minWidth Dialog width
 * @param {*} minHeight Dialog Heigth
 * @param {*} marginTopImage margon of first Image
 * @param {*} minWidthButtonAcept width accept button
 * @returns a object with dinamic styles
 */
const alertStyles = (
  theme,
  firstImageIcon,
  minWidth,
  minHeight,
  marginTopImage,
  minWidthButtonAcept,
  paddingBottom = 15,
) => ({
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom,
  },
  dialogStyle: { minWidth, minHeight },
  firstImage: firstImageIcon,
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  styleTitle: {
    fontFamily: 'Mulish, sans-serif',
    fontSize: '20px',
    fontWeight: 700,
    marginTop: '-25px',
  },
  styleButtonAcept: {
    backgroundColor: '#FFFFFF',
    color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
    border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
    minWidth: minWidthButtonAcept,
  },
});

const CertificationServicesEdit = (props) => {
  const {
    productType,
    listDeviceTypeContracts,
    listValidityTypeContracts,
    transformedListMaxValidityAmountContracts,
    parameterMaxReassignmentQuota,
    listCredentialDeliveryContracts,
    setValueProducts,
    getValuesProducts,
    resetProduct,
    clearErrorsProducts,
    controlProducts,
    errorsProducts,
    handleSubmitProducts,
    theme,
    classes,
    deviceTypeOptions,
    setDeviceTypeOptions,
    isEditing,
    setIsEditing,
    servicesToAdd,
    setServicesToAdd,
    selectedIndex,
    setSelectedIndex,
    credentialsOptions,
    setCredentialsOptions,
    formatNumberWithCommas,
    listCredentialParams,
  } = props;
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;
  const { enqueueSnackbar } = useSnackbar();
  const [productToEdit, setProductToEdit] = useState({});
  const [alertInfo, setAlertInfo] = useState({});
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [canSeeErrors, setCanSeeErrors] = useState(true);
  const succesfullColor = theme?.miplan?.hoverButtonCard?.backgroundColor;

  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);

  const OwnSuccesfullIcon = useMemo(() => (
    <SuccesfullIcon color={succesfullColor} />
  ), [succesfullColor]);

  /**
   * Set credential delivery options foer each device type:
   * TK Token P12 PKS12 FC Firma centralizada
   * @param {*} value of device type
   */
  const setCorrectCredentialOption = (value) => {
    // console.log('deviceOptions', deviceTypeOptions);
    const listAviableCredentials = getDeviceTye(deviceTypeOptions, 'codeDevice', listCredentialParams);
    // console.log('la lista de donde se filtra', listCredentialDeliveryContracts);
    if (listAviableCredentials) {
      setCredentialsOptions(listCredentialDeliveryContracts.filter(
        (option) => listAviableCredentials.includes(option.value),
        // If the list of credentials matches those parameterized in the database
      ));
    } else if (value === 1) {
      setCredentialsOptions(listCredentialDeliveryContracts.filter((option) => option.value === 1));
    } else if (value === 2) {
      setCredentialsOptions(listCredentialDeliveryContracts);
    }
  };

  /**
   * It is executed when a product is edited,
   * in which case the sending of credentials must be
   * established according to the product in the selected list
   */
  useEffect(() => {
    if (deviceTypeOptions.length > 0) {
      setCorrectCredentialOption(productToEdit.deviceType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceTypeOptions, productToEdit]);

  const setProductType = (event) => {
    setValueProducts('deviceType', '');
    setValueProducts('credentialsDeliveryType', '');
    setCanSeeErrors(true);// only for quantity
    const { value } = event.target;
    if (event.target.name === 'productService') {
      setValueProducts('productService', value);
    }
    if (productType.length > 0) {
      const deviceTypeId = productType.find(
        (pack) => pack.value === getValuesProducts('productService'),
      )?.deviceTypeId;
      const deviceTypeIdsArray = deviceTypeId
        ? deviceTypeId.split(',').map(Number)
        : [];
      if (deviceTypeIdsArray.length > 0) {
        setDeviceTypeOptions(
          listDeviceTypeContracts.filter((option) => deviceTypeIdsArray.includes(option.value)),
        );
      } else {
        setDeviceTypeOptions([]);
      }
    }
    return value;
  };

  const setValidityType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'validityService') {
      setValueProducts('validityService', value);
      setValueProducts('validityAmount', '');
    }
    return value;
  };

  const setDeviceType = (event) => {
    setValueProducts('credentialsDeliveryType', '');
    const { value } = event.target;
    if (event.target.name === 'deviceType') {
      setValueProducts('deviceType', value);
    }
    setCorrectCredentialOption(value);
    return value;
  };

  const setCredentialsType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'credentialsDeliveryType') {
      setValueProducts('credentialsDeliveryType', value);
    }
    return value;
  };

  const handleAgregarProducto = (data) => {
    if (isEditing) {
      const codeDevice = listDeviceTypeContracts.find(
        (validity) => validity.value === data.deviceType,
      )?.codeDevice;
      const identifierCode = `${data.productService}_${codeDevice}_${data.validityAmount}${data.validityService}`;

      const exists = servicesToAdd.some((serv, index) => {
        const codeDeviceService = listDeviceTypeContracts.find(
          (validity) => validity.value === serv.deviceType,
        )?.codeDevice;
        return index !== selectedIndex && identifierCode === `${serv.productService}_${codeDeviceService}_${serv.validityAmount}${serv.validityService}`;
      });

      if (exists) {
        enqueueSnackbar('Ya existe el producto en la lista.', {
          variant: 'warning',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        });
        return;
      }
      setServicesToAdd((prevServices) => prevServices.map(
        (service, index) => (index === selectedIndex ? { ...service, ...data } : service),
      ));
    } else {
      const codeDevice = listDeviceTypeContracts.find(
        (validity) => validity.value === data.deviceType,
      )?.codeDevice;
      const identifierCode = `${data.productService}_${codeDevice}_${data.validityAmount}${data.validityService}`;

      const exists = servicesToAdd.some((serv) => {
        const codeDeviceService = listDeviceTypeContracts.find(
          (validity) => validity.value === serv.deviceType,
        )?.codeDevice;
        return identifierCode === `${serv.productService}_${codeDeviceService}_${serv.validityAmount}${serv.validityService}`;
      });

      if (exists) {
        enqueueSnackbar('Ya existe el producto en la lista.', {
          variant: 'warning',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        });
        return;
      }

      setServicesToAdd((prevServices) => [...prevServices, data]);
    }
    setValueProducts('productService', '');
    setValueProducts('quantityToAddService', '');
    setValueProducts('validityService', '');
    setValueProducts('validityAmount', '');
    setValueProducts('reassignmentQuota', '');
    setValueProducts('deviceType', '');
    setValueProducts('credentialsDeliveryType', '');
    setIsEditing(false);
    setCanSeeErrors(false);
    setSelectedIndex(null);
    resetProduct();
    setDeviceTypeOptions([]);
    setCredentialsOptions([]);
  };

  const handleEditProduct = (index) => {
    const product = servicesToAdd[index];
    setProductToEdit(product);
    if (productType.length > 0) {
      const deviceTypeId = productType.find(
        (pack) => pack.value === product.productService,
      )?.deviceTypeId;
      const deviceTypeIdsArray = deviceTypeId ? deviceTypeId.split(',').map(Number) : [];
      if (deviceTypeIdsArray.length > 0) {
        setDeviceTypeOptions(listDeviceTypeContracts.filter(
          (option) => deviceTypeIdsArray.includes(option.value),
        ));
      }
    }
    setIsEditing(true);
    setSelectedIndex(index);
    clearErrorsProducts();
  };

  const deleteProduct = (index) => {
    setIsAlertOpen(false);
    setTimeout(() => {
      setValueProducts('productService', '');
      setValueProducts('quantityToAddService', '');
      setValueProducts('validityService', '');
      setValueProducts('validityAmount', '');
      setValueProducts('reassignmentQuota', '');
      setValueProducts('deviceType', '');
      setValueProducts('credentialsDeliveryType', '');
      setIsEditing(false);
      setSelectedIndex(null);
      resetProduct();
      setServicesToAdd((prevServices) => prevServices.filter((_, i) => i !== index));
      setDeviceTypeOptions([]);
      setCredentialsOptions([]);
      setAlertInfo({
        tituloModal: '¡Servicio eliminado!',
        showClose: false,
        isOnlyMessage: true,
        messageAlert: alertStyles(theme, OwnSuccesfullIcon, '508px', '284px', 65),
      });
      setIsAlertOpen(true);
      setTimeout(() => {
        setIsAlertOpen(false);
      }, 2000);
    }, 1000);
  };

  const handleDeleteProduct = (index) => {
    setAlertInfo({
      tituloModal: '¿Quieres eliminar este servicio?',
      textButtonAcept: 'Eliminar servicio',
      onCancel: true,
      onClose: () => setIsAlertOpen(false),
      handleAccept: () => deleteProduct(index),
      messageAlert: alertStyles(theme, OwnWarningIcon, '508px', '291px', 40, '40%'),
      showClose: false,
      isOnlyMessage: false,
    });
    setIsAlertOpen(true);
  };

  return (
    <>
      <Grid item xs={12} style={{ paddingLeft: '0px', paddingBottom: '32px' }}>
        <Typography align="left" className={classes.titleForm} variant="h6">
          Servicios Contratados
        </Typography>
      </Grid>
      <Container component="main" maxWidth="lg" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
        <form autoComplete="off">
          <Grid
            container
            spacing={3}
          >
            <Grid item xs={12} md={8}>
              <InputLabel />
              <CustomSelect
                label="Servicios"
                name="productService"
                options={productType}
                control={controlProducts}
                rule={Rules.required}
                required
                error={errorsProducts}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setProductType(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <NumberFormatCustom
                label="Cantidad"
                name="quantityToAddService"
                control={controlProducts}
                error={canSeeErrors ? errorsProducts : []}
                required
                rule={canSeeErrors ? Rules.positiveValue : []}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                setValue={setValueProducts}
                classes={classes.typeInput}
                inputProps={{
                  maxLength: 10,
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputLabel />
              <CustomSelect
                label="Tipo vigencia"
                name="validityService"
                options={listValidityTypeContracts}
                control={controlProducts}
                required
                rule={Rules.required}
                error={errorsProducts}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setValidityType(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CustomInput
                label="Vigencia"
                name="validityAmount"
                control={controlProducts}
                error={errorsProducts}
                required
                rule={Rules.numerico}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 5,
                }}
                onValidate={(e) => {
                  if (e.target.value <= 0) {
                    setValueProducts('validityAmount', '');
                  }
                  const valueTypeValidity = getValuesProducts('validityService');
                  if (transformedListMaxValidityAmountContracts.length > 0) {
                    const valueMax = transformedListMaxValidityAmountContracts.find(
                      (maxValidity) => maxValidity.value === valueTypeValidity,
                    )?.amount;
                    if (e.target.value > valueMax) {
                      setValueProducts('validityAmount', '');
                    }
                  }
                }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CustomInput
                label="Cupo Reasignación"
                name="reassignmentQuota"
                control={controlProducts}
                error={errorsProducts}
                required
                rule={Rules.numerico}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 5,
                }}
                onValidate={(e) => {
                  if (e.target.value.startsWith('0')) {
                    setValueProducts('reassignmentQuota', '0');
                  }
                  if (
                    e.target.value < 0 || e.target.value > parameterMaxReassignmentQuota
                  ) {
                    setValueProducts('reassignmentQuota', '');
                  }
                }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputLabel />
              <CustomSelect
                label="Tipo de dispositivo"
                name="deviceType"
                options={deviceTypeOptions}
                control={controlProducts}
                rule={Rules.required}
                required
                error={errorsProducts}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setDeviceType(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputLabel />
              <CustomSelect
                label="Tipo entrega credenciales"
                name="credentialsDeliveryType"
                options={credentialsOptions}
                control={controlProducts}
                rule={Rules.required}
                required
                error={errorsProducts}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setCredentialsType(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '24px',
                marginBottom: servicesToAdd.length > 0 ? 20 : 32,
              }}
            >
              <Box className={classes.submit}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  size="medium"
                  className={classes.btnBlueSubmit}
                  onClick={handleSubmitProducts(handleAgregarProducto)}
                >
                  Crear servicio
                </Button>
                {/* {isEditing && (
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    size="medium"
                    className={classes.btnBlueSubmit}
                    onClick={handleCancelEdit}
                  >
                    Cancelar edición
                  </Button>
                )} */}
              </Box>
            </Grid>
            {servicesToAdd && servicesToAdd.length > 0 ? (
              <Grid
                item
                xs={12}
                style={{ marginBottom: 32 }}
              >
                <Box style={{ minWidth: '500px' }}>
                  <TableContainer
                    component={Paper}
                    style={{
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      boxShadow: 'none',
                    }}
                    className={classes.scrollBar}
                  >
                    <Table style={{ minWidth: 300, whiteSpace: 'nowrap' }}>
                      <TableHead className={classes.tableHead}>
                        <TableRow>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottomLeftRadius: 10, borderBottom: 'none' }}
                          >
                            Servicio
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Cantidad
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Tipo de
                            <br />
                            vigencia
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Vigencia
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Cupo
                            <br />
                            reasignación
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Tipo de
                            <br />
                            dispositivo
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Tipo de
                            <br />
                            entrega
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableCell}
                            style={{ borderBottomRightRadius: 10, borderBottom: 'none' }}
                          />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {servicesToAdd.map((service, index) => (
                          <TableRow key={index}>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                                whiteSpace: 'normal',
                              }}
                            >
                              {productType.find(
                                (product) => product.value === service.productService,
                              )?.label || 'Desconocido'}
                            </TableCell>
                            <TableCell
                              align="right"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {formatNumberWithCommas(service.quantityToAddService)}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {listValidityTypeContracts.find(
                                (validity) => validity.value === service.validityService,
                              )?.label || 'Desconocido'}
                            </TableCell>
                            <TableCell
                              align="right"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {service.validityAmount}
                            </TableCell>
                            <TableCell
                              align="right"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {service.reassignmentQuota}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                                whiteSpace: 'normal',
                              }}
                            >
                              {listDeviceTypeContracts.find(
                                (validity) => validity.value === service.deviceType,
                              )?.label || 'Desconocido'}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                                whiteSpace: 'normal',
                              }}
                            >
                              {listCredentialDeliveryContracts.find(
                                (validity) => validity.value === service.credentialsDeliveryType,
                              )?.label || 'Desconocido'}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#333',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'end',
                                }}
                              >
                                <IconButton
                                  onClick={() => handleEditProduct(index)}
                                  style={{
                                    fontSize: '24px',
                                    color: theme.palette.primary.main,
                                  }}
                                >
                                  <EditIcon />
                                </IconButton>
                                {!service?.isExist && (
                                  <IconButton
                                    onClick={() => handleDeleteProduct(index)}
                                    style={{
                                      fontSize: '24px',
                                      marginLeft: '10px',
                                      color: theme.palette.primary.main,
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}

                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </form>
      </Container>
      <EditCertificationServiceModify
        openClose={
          {
            isOpen: isEditing,
            close: setIsEditing,
            setAlertInfo,
            setIsAlertOpen,
          }
        }
        products={
          {
            currentProduct: productToEdit,
            listProducts: productType,
            vigencyList: listValidityTypeContracts,
            deviceList: deviceTypeOptions,
            credentialsOptions,
          }
        }
        styles={
          {
            typeInput: classes.typeInput,
            buttonStyles: classes.btnBlueSubmit,
            cancelButton: classes.btnSubmit,
            alertStyles,
            OwnSuccesfullIcon,
          }
        }
        form={
          {
            maxValidityAmount: transformedListMaxValidityAmountContracts,
            reasigmentQuota: parameterMaxReassignmentQuota,
          }
        }
        modifyProduct={
          {
            currentIndex: selectedIndex,
            setServicesToAdd,
          }
        }
      />
      <AlertConfirm
        isOpen={isAlertOpen}
        tituloModal={alertInfo?.tituloModal}
        textButtonAcept={alertInfo?.textButtonAcept}
        mensajeModal={alertInfo?.mensajeModal}
        handleAccept={alertInfo?.handleAccept}
        onCancel={alertInfo?.onCancel}
        onClose={alertInfo?.onClose}
        messageAlert={alertInfo?.messageAlert}
        showClose={alertInfo?.showClose}
        isOnlyMessage={alertInfo?.isOnlyMessage}
      />
    </>
  );
};

export default CertificationServicesEdit;
